/* Upsells im Warenkorb: Variante wählen und mit einem Klick hinzufügen (LimeAds) */
(() => {
  if (window.poCartUpsell) return;
  window.poCartUpsell = true;

  // Kaching gibt das Geschenk nur gratis, wenn Set-Zeilen und Geschenk dieselbe Kaching-Gruppe tragen
  const kachingProps = (item) => {
    try {
      return item.properties && item.properties.__kaching_bundles ? JSON.parse(item.properties.__kaching_bundles) : null;
    } catch (e) {
      return null;
    }
  };
  const poKaching = {
    dealFrom(root, productId) {
      for (const node of root.querySelectorAll('script.kaching-bundles-deal-block-settings')) {
        try {
          const deal = JSON.parse(node.textContent);
          if ((deal.selectedProductIds || []).map(String).includes(String(productId))) return deal;
        } catch (e) {
          /* nächsten Deal versuchen */
        }
      }
      return null;
    },
    async dealForHandle(handle, productId) {
      const html = await fetch(`/products/${handle}`).then((r) => r.text());
      return poKaching.dealFrom(new DOMParser().parseFromString(html, 'text/html'), productId);
    },
    // Geschenk ohne feste Variante in Kaching: erste verfügbare Variante des Produkts nehmen
    async giftVariant(deal, gift) {
      const fixed = parseInt(String((gift.variantGIDs || [])[0] || '').split('/').pop(), 10);
      if (fixed) return fixed;
      const productId = String(gift.productGID || '').split('/').pop();
      for (const handle of deal.otherProductHandles || []) {
        const product = await fetch(`/products/${handle}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null);
        if (product && String(product.id) === productId) {
          const variant = product.variants.find((v) => v.available) || product.variants[0];
          return variant ? variant.id : null;
        }
      }
      return null;
    },
    // Zeilen für /cart/add.js: je Eintrag in variantIds ein Set, dazu die Geschenke der erreichten Kaching-Stufe
    async lines(deal, cart, productId, variantIds, withGifts) {
      const own = cart.items.filter((i) => i.product_id === productId && !(i.properties && i.properties._po_gift));
      const existing = own.map(kachingProps).find((p) => p && p.main && p.deal === deal.nanoId);
      const group = existing ? existing.id : Math.random().toString(36).slice(2, 6);
      const total = own.reduce((sum, i) => sum + i.quantity, 0) + variantIds.length;
      const bar = deal.dealBars.filter((b) => b.quantity <= total).sort((a, b) => b.quantity - a.quantity)[0];
      const items = [];
      variantIds.forEach((id) => {
        const line = items.find((l) => l.id === id);
        if (line) {
          line.quantity += 1;
          return;
        }
        const props = { deal: deal.nanoId, pp: productId, main: true, v: deal.versionId, id: group };
        // Gleiche Kennzeichnung wie die vorhandenen Sets, damit gleiche Farben in einer Zeile landen
        const bid = existing ? existing.bid : bar && bar.id;
        if (bid) props.bid = bid;
        items.push({ id, quantity: 1, properties: { __kaching_bundles: JSON.stringify(props) } });
      });
      if (withGifts && bar) {
        for (const gift of bar.freeGifts || []) {
          const giftId = await poKaching.giftVariant(deal, gift);
          if (!giftId || cart.items.some((i) => i.variant_id === giftId && i.properties && i.properties._po_gift)) continue;
          // Ab welcher Set-Anzahl Kaching dieses Produkt verschenkt (für das Entfernen beim Reduzieren)
          const need = deal.dealBars
            .filter((b) => (b.freeGifts || []).some((g) => g.productGID === gift.productGID))
            .map((b) => b.quantity)
            .sort((a, b) => a - b)[0] || bar.quantity;
          items.push({
            id: giftId,
            quantity: gift.quantity || 1,
            properties: {
              Geschenk: 'gratis',
              __kaching_bundles: JSON.stringify({ id: group, deal: deal.nanoId, v: deal.versionId, gift: gift.id }),
              _po_gift: String(need),
              _po_for: String(productId)
            }
          });
        }
      }
      return items;
    }
  };
  window.poKaching = poKaching;

  document.addEventListener('change', (event) => {
    const select = event.target.closest('.po-cu__select');
    if (!select) return;
    const option = select.selectedOptions[0];
    const price = select.closest('.po-cu__card').querySelector('[data-price]');
    if (price && option && option.dataset.price) price.textContent = option.dataset.price;
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-po-add]');
    if (!button || button.disabled) return;
    const card = button.closest('.po-cu__card');
    const select = card.querySelector('.po-cu__select');
    const id = parseInt(select ? select.value : button.dataset.variant, 10);
    if (!id) return;

    button.disabled = true;
    button.classList.add('is-loading');
    try {
      let items = [{ id, quantity: 1 }];
      let deal = null;
      if (button.dataset.kachingHandle) {
        const productId = parseInt(button.dataset.for, 10);
        const [found, cart] = await Promise.all([
          poKaching.dealForHandle(button.dataset.kachingHandle, productId).catch(() => null),
          fetch('/cart.js').then((r) => r.json())
        ]);
        deal = found;
        if (deal) items = await poKaching.lines(deal, cart, productId, [id], true);
      }
      // Ohne Kaching-Deal: Geschenk wie früher mitgeben, falls es noch fehlt
      if (!deal && button.dataset.giftId) {
        const giftId = parseInt(button.dataset.giftId, 10);
        const cart = await fetch('/cart.js').then((r) => r.json());
        const hasGift = cart.items.some((i) => i.variant_id === giftId && i.properties && i.properties._po_gift);
        if (!hasGift) {
          items.push({
            id: giftId,
            quantity: 1,
            properties: { Geschenk: 'gratis', _po_gift: button.dataset.giftTier, _po_for: button.dataset.for }
          });
        }
      }

      const drawer = document.querySelector('cart-drawer');
      const body = { items };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        body.sections = drawer.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
      }
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then((r) => r.json());
      if (res.status) throw new Error(res.description || res.message);

      if (/\/cart\/?$/.test(window.location.pathname)) {
        window.location.reload();
      } else if (drawer && res.sections && typeof drawer.renderContents === 'function') {
        drawer.renderContents(res);
      }
      if (typeof window.publish === 'function') window.publish('cart-update', { source: 'po-cart-upsell' });
    } catch (error) {
      button.classList.remove('is-loading');
      button.textContent = 'Nicht verfügbar';
    }
  });
})();
